import React from 'react';
import { setValidationsData } from '../../../redux/actions';
import { useDispatch } from 'react-redux';

export const ConsultMonitoring = {
    Header: () => 'Seguimiento',
    id: 'seguimiento',
    Cell: ({ row }) => {
        const dispatch = useDispatch();
        return (
            <div>
                <span className="finamiga-color" style={{ cursor: 'pointer' }} onClick={() => dispatch(setValidationsData({ showMonitoring: row.original }))}>
                    {row.original?.seguimiento_comercial_novedad?.label}
                </span>
            </div>
        );
    },
};
